<script>
/**
 * 首页「两大业务线」大卡片（自 vancheen-b2b 的 PillarCard.vue 移植为 Vue 2 版本）
 */
import NhLink from './NhLink.vue'
import NhSvgIcon from './NhSvgIcon.vue'
import asset from '../nh-asset'

export default {
  name: 'NhPillarCard',
  components: { NhLink, NhSvgIcon },
  props: {
    pillar: { type: Object, required: true },
    delay: { type: [Number, String], default: undefined }
  },
  methods: {
    asset
  }
}
</script>

<template>
  <NhLink
    v-reveal="delay"
    class="pillar-card"
    :class="pillar.key"
    :to="pillar.to"
  >
    <div class="pillar-bg">
      <img :src="asset(pillar.img)" :alt="pillar.alt">
    </div>
    <div class="pillar-body">
      <span class="pillar-tag">{{ pillar.tag }}</span>
      <h3>{{ pillar.title }}</h3>
      <p>{{ pillar.desc }}</p>
      <div class="pillar-series">
        <span v-for="s in pillar.series" :key="s">{{ s }}</span>
      </div>
      <span class="pillar-link">{{ pillar.linkText }} <NhSvgIcon name="arrow" /></span>
    </div>
  </NhLink>
</template>
